import React from 'react';
import styled from 'styled-components';

import useTranslation from 'hooks/use-translation';
import { ModalExitIcon, ModalFooter } from 'components/core';
import { ModalContent, HeaderText, ModalFooterText, SignUpText } from 'components/modals/components';

import { useModals, ModalNames } from 'components/modals';
import LoginForm from 'components/forms/login-form';
import useUI from 'src/hooks/use-ui';

export type LoginModalContentProps = {
  onClose: () => void;
};

export function LoginModalContent({ onClose }: LoginModalContentProps): JSX.Element {
  const { openModal } = useModals();
  const { t } = useTranslation();
  const { isMobileEcommApp } = useUI();

  const handleOpenSignUpModal = (): void => {
    onClose();
    void openModal(ModalNames.signUp);
  };

  return (
    <>
      <ModalExitIcon onClick={onClose} />
      <ModalContent pb={92}>
        <HeaderText pt={26} mb={25} mt={0}>
          {t('loginModal.header', 'Log in to your account')}
        </HeaderText>

        <LoginForm onClose={onClose} />
      </ModalContent>
      {!isMobileEcommApp && (
        <ModalFooter>
          <ModalFooterText>{t('loginModal.footerText', 'New to Dutchie?')}</ModalFooterText>
          <StyledSignUpText onClick={handleOpenSignUpModal}>{t('loginModal.footerSignUp', 'Sign Up')}</StyledSignUpText>
        </ModalFooter>
      )}
    </>
  );
}

const StyledSignUpText = styled(SignUpText)`
  margin-left: 0;
  padding-left: 5px;
`;
